export enum TimeSlot {
  Indiferent = 1,
  Mornings = 2,
  Afternoon = 3
}
